<template>
    <div class="application-shell">
        <header class="site-header">
            <div class="layout-container header-inner">
                <div class="brand">
                    <strong>Al-Mustafa</strong>
                    <span>Institut Berlin</span>
                </div>

                <div class="language-switch" role="group" :aria-label="$t('language')">
                    <button type="button" :class="{ active: locale === 'de' }" @click="locale = 'de'">DE</button>
                    <button type="button" :class="{ active: locale === 'en' }" @click="locale = 'en'">EN</button>
                </div>
            </div>
        </header>

        <section class="application-hero">
            <div class="layout-container hero-inner">
                <span class="hero-eyebrow">{{ $t('heroEyebrow') }}</span>
                <h1>{{ $t('heroTitle') }}</h1>
                <p>{{ $t('heroDescription') }}</p>
            </div>
        </section>

        <main class="form-wrap">
            <slot />
        </main>

        <footer class="site-footer">© Al-Mustafa Institut Berlin</footer>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { locale } = useI18n()
</script>

<style scoped>
.application-shell {
    min-height: 100vh;
    background: var(--page);
    color: var(--text);
}

.layout-container {
    width: min(100%, 1040px);
    margin: 0 auto;
    padding-right: 40px;
    padding-left: 40px;
}

.site-header {
    border-bottom: 1px solid var(--border);
    background: var(--surface);
}

.header-inner {
    display: flex;
    min-height: 76px;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
}

.brand {
    display: flex;
    flex-direction: column;
    line-height: 1.1;
}

.brand strong {
    font: 600 21px var(--font-heading);
}

.brand span {
    color: var(--accent);
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
}

.language-switch {
    display: flex;
    gap: 2px;
    padding: 3px;
    border-radius: 999px;
    background: var(--soft);
}

.language-switch button {
    padding: 6px 13px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: var(--muted);
    cursor: pointer;
    font: 700 12px var(--font-body);
}

.language-switch button.active {
    background: var(--accent);
    color: #fff;
}

.application-hero {
    background: var(--accent);
    color: #fff;
}

.hero-inner {
    padding-top: 52px;
    padding-bottom: 88px;
}

.hero-inner > * {
    max-width: 610px;
}

.hero-eyebrow {
    color: rgba(255, 255, 255, .85);
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .1em;
    text-transform: uppercase;
}

.hero-inner h1 {
    margin: 14px 0 12px;
    font: 600 38px/1.2 var(--font-heading);
}

.hero-inner p {
    margin: 0;
    font-size: 15px;
    line-height: 1.65;
}

.form-wrap {
    position: relative;
    width: min(100%, 1040px);
    margin: -48px auto 0;
    padding: 0 40px 64px;
}

.site-footer {
    padding: 28px 40px 40px;
    color: var(--placeholder);
    font-size: 12px;
    text-align: center;
}

@media (max-width: 820px) {
    .layout-container,
    .form-wrap {
        padding-right: 20px;
        padding-left: 20px;
    }

    .hero-inner h1 {
        font-size: 30px;
    }
}
</style>
